<script lang='ts'>
	import DOMPurify from 'dompurify'
	import { marked } from 'marked'

    // import { onMount } from 'svelte'
	import { account } from '$lib/stores/account/account'
    import { openai_thread_items_store } from '$lib/stores/openai_thread_items/openai_thread_items'
    import { InitOpenaiThreadItems } from '$lib/stores/openai_thread_items/openai_thread_items'


	let data = []
	$: data = $openai_thread_items_store
	$: {
		if($account.openai_thread_id){
			InitOpenaiThreadItems($account.openai_thread_id)
		}
	}

	const sanitizeAndParse = (text: string) => {
		const parsed = marked.parse(text, { 
			async: false,
			breaks: false,
			gfm: true
		})
		// More aggressive line break removal
		const cleanText = parsed
			.replace(/\n/g, ' ')  // Replace all newlines with spaces
			.replace(/\s+/g, ' ') // Collapse multiple spaces into one
		return DOMPurify.sanitize(cleanText)
	}

</script>



<div class="messages">
	{#if data}

		{#each data as msg}

			<div class="userMessage">
				{msg.question}
			</div>
			<div 
				data-test-id="openai_chat_response"
				class="assistantMessage">
				<!-- <Markdown>{msg.text}</Markdown> -->
				<!-- {@html msg.text} -->
				{@html sanitizeAndParse(msg.response)}
			</div>
			<!-- <div 
				data-test-id="openai_chat_response"
				class="markdown-content">
				{@html sanitizeAndParse(msg.response)}
			</div> -->

		{/each}
	{/if}
</div>




<style lang='postcss'>
	.messages {
		flex-grow: 1;
		overflow-y: auto;
		padding: 10px;
		display: flex;
		flex-direction: column;
		order: 2;
		white-space: pre-wrap;
		@apply text-sm;
	}

	.userMessage,
	.assistantMessage {
		margin: 8px 0;
		padding: 8px 16px;
		align-self: flex-start;
		border-radius: 8px;
		max-width: 80%;
		overflow-wrap: break-word;
	}


	.userMessage {
		@apply bg-emerald-500 text-white;
		align-self: flex-end;
		color: #fff;
		text-align: right;
		border-radius: 8px;
	}

	.assistantMessage {
		font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
		border-left: 4px solid #10a37f;
		background-color: #efefef;
		white-space: normal;
		/* Add these properties */
		word-wrap: break-word;
		word-break: break-word;
	}


	.assistantMessage :global(img) {
		max-width: 100%;
		margin: 8px 0px 8px 0px;
		border-radius: 8px;
		white-space: normal; /* avoid line breaks */
	}

	.assistantMessage :global(li) {
		padding: .25rem 0px .25rem 20px;
	}

	/* Add this to handle paragraphs within the message */
	.assistantMessage :global(p) {
		/* margin: 0; */
		/* display: inline; */
		padding: .25rem 0px .25rem 0px;
		/* background-color: lightblue; */
	}

	/* Code Blocks */
	.assistantMessage :global(pre) {
	background-color: #282c34;
	color: #f8f8f2;
	padding: 12px;
	border-radius: 8px;
	font-family: "Courier New", monospace;
	overflow-x: auto;
	}

	.assistantMessage :global(code) {
	background: none;
	padding: 0;
	color: inherit;
	margin: 0px;
	padding: 0px;
	}

	/* ===================================== */

	.markdown-content {
		@apply text-sm;
		margin: 8px 0;
		padding: 8px 16px;
		align-self: flex-start;
		border-radius: 8px;
		max-width: 80%;
		overflow-wrap: break-word;

		font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
		/* font-size: 16px; */
		/* line-height: 1.6; */
		/* color: #333; */
		background-color: #efefef;
		border-left: 4px solid #10a37f;
	}


	/* Headings */
	.markdown-content :global(h1) {
	font-size: 24px;
	color: #0d6efd;
	border-bottom: 2px solid #e0e0e0;
	padding-bottom: 4px;
	}

	.markdown-content :global(h2) {
	font-size: 20px;
	color: #0d6efd;
	border-bottom: 1px solid #e0e0e0;
	padding-bottom: 4px;
	}

	.markdown-content :global(h3) {
	font-size: 18px;
	color: #0d6efd;
	}

	/* Paragraphs */
	.markdown-content :global(p) {
	/* margin: 10px 0; */

	margin: 0px;
	padding: 0px;
	}

	/* Lists */
	.markdown-content :global(ul), 
	.markdown-content :global(ol) {
	margin: 0px;  
	padding: 0px;
	}

	.markdown-content :global(li) {
	/* margin-bottom: 6px; */

	margin: 0px;
	padding: 0px;
	padding-left: 20px;

	}

	/* Blockquotes */
	.markdown-content :global(blockquote) {
	border-left: 4px solid #10a37f;
	/* margin: 10px 0;
	padding: 10px; */
	margin: 0px;
	padding: 0px;

	font-style: italic;
	background: #f0f7f5;
	color: #555;
	border-radius: 4px;
	}

	/* Inline Code */
	.markdown-content :global(code) {
	background-color: #e9ecef;
	padding: 2px 6px;
	font-family: "Courier New", monospace;
	border-radius: 4px;
	font-size: 14px;
	color: #d63384;
	margin: 0px;
	padding: 0px;
	}

	/* Code Blocks */
	.markdown-content :global(pre) {
	background-color: #282c34;
	color: #f8f8f2;
	padding: 12px;
	border-radius: 8px;
	font-family: "Courier New", monospace;
	overflow-x: auto;
	}

	.markdown-content :global(code) {
	background: none;
	padding: 0;
	color: inherit;
	margin: 0px;
	padding: 0px;
	}

	/* Horizontal Rule */
	.markdown-content :global(hr) {
	border: 0;
	height: 1px;
	background: #e0e0e0;
	/* margin: 20px 0; */
	margin: 0px;
	padding: 0px;
	}

	/* Links */
	.markdown-content :global(a) {
	color: #007bff;
	text-decoration: none;
	}

	.markdown-content :global(a):hover {
	text-decoration: underline;
	}

</style>